let initialState = {
	modalId: null
}

let modalReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'SET_MODAL':
			return {
				...state,
				modalId: action.id,
			}

		default:
			return state
	}
}

export const setModal = (id) => ({ type: 'SET_MODAL', id })

export default modalReducer
